import React from 'react';
import ProfilePostList from './ProfilePostList';

function MyPost() {
    return (
        <ProfilePostList endpoint={"posts"}/>
    );
}

export default MyPost;